







































import { focus } from '~/helpers/directives';
import { defineComponent } from '@nuxtjs/composition-api';
import SfTransition from '~/helpers/utilities/transitions/components/SfTransition';
import SfChevron from '../SfChevron/SfChevron.vue';
import SfButton from '../SfButton/SfButton.vue';

export default defineComponent({
  name: 'SfAccordionItem',
  directives: { focus },
  components: {
    SfChevron,
    SfButton,
    SfTransition,
  },
  props: {
    header: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    accordionClick() {
      this.$parent.$emit('toggle', this._uid);
    },
  },
});
